import bannerImg from './banners/woman-helping-man-gym.jpg';

export default {
    id: 'lead-treino-online',
    title: 'Captação de leads — Treino online',
    description: 'Formulário simples e direto para capturar leads interessados no seu programa de treinos online.',
    indicatedFor: 'Personal trainers',
    stepsCount: 1,
    questionsSummary: ['Nome e contato', 'Objetivo principal', 'Disponibilidade', 'Como conheceu'],
    banner: `url(${bannerImg}) center / cover no-repeat`,
    formData: {
        title: 'Quero começar a treinar online',
        active: false,
        allow_multiple_answers: false,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: 'Vamos começar!',
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: 'Quero minha vaga',
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'full_name',
                        label: 'Qual é o seu nome?',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'email',
                        label: 'Qual é o seu e-mail?',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 3,
                        type: 'phone',
                        label: 'Qual é o seu WhatsApp?',
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 4,
                        type: 'choices',
                        label: 'Qual é o seu principal objetivo com o treino?',
                        description: null,
                        required: true,
                        settings: {
                            options: [
                                { id: 'opt-1', label: 'Emagrecer' },
                                { id: 'opt-2', label: 'Ganhar massa muscular' },
                                { id: 'opt-3', label: 'Melhorar o condicionamento' },
                                { id: 'opt-4', label: 'Saúde e bem-estar' },
                            ],
                        },
                    },
                    {
                        order: 5,
                        type: 'choices',
                        label: 'Como você ficou sabendo do programa?',
                        description: null,
                        required: false,
                        settings: {
                            options: [
                                { id: 'opt-1', label: 'Instagram' },
                                { id: 'opt-2', label: 'Indicação de amigo' },
                                { id: 'opt-3', label: 'YouTube' },
                                { id: 'opt-4', label: 'TikTok' },
                                { id: 'opt-5', label: 'Outro' },
                            ],
                        },
                    },
                ],
            },
        ],
        actions: [],
    },
};
